import karkala from '../assets/sanghas/karkala.jpg';
import udupi from '../assets/sanghas/udupi.avif';
import surathkal from '../assets/sanghas/surathkal.jpg';
import mangalore from '../assets/sanghas/mangalore.jpg';
import nerul from '../assets/sanghas/nerul.avif';
import Devadigayuvasangatane from '../assets/sanghas/Devadigayuvasangatane.jpg';
import dsbhiriyadka from '../assets/sanghas/dsbhiriyadka.jpg';
import DevadigaWelfareAssociation from '../assets/sanghas/DevadigaWelfareAssociation.jpg';

const SanghaData = [
    {
        id: 1,
        title: 'Devadiga Sangha Mumbai',
        address: '70A, Hindtej Building, Dada Saheb Phalke Road, Dadar East, Mumbai, Maharashtra 400014',
        phone: '022 2411 2563',
        links: [
            {
                href: 'http://devadigasanghamumbai.com/',
                text: 'Website'
            },
            {
                href: 'https://devadigasangha.blogspot.com/',
                text: 'Blogger'
            },
            {
                href: 'mailto:devadigasanghamumbai@gmail.com',
                text: 'Email'
            }
        ]
    },
    {
        id: 2,
        title: 'Devadiga Regional Cultural Centre',
        address: 'Devadiga Bhavan Plot No 12, Sector 12, Nerul West, Navi Mumbai, Maharashtra 400706',
        phone: '022 2411 2563',
        image: nerul,
        links: [
            {
                href: 'https://www.google.com/search?q=Devdiga+Bhavan+Nerul',
                text: 'Google'
            }
        ]
    },
    {
        id: 3,
        title: 'Devadiga Sangha Udupi',
        address: 'Shardamantapa Beedinagudde road, Chitpadi, Udupi - 576101 (Bidinaguddy)',
        image: udupi,
        phone: '',
        links: [
            {
                href: 'https://www.facebook.com/devadigasangha.udupi/',
                text: 'Facebook'
            }
        ]
    },
    {
        id: 4,
        title: 'Karnataka Rajya Devadigara Sangha REGD Mangalore official ',
        address: 'Devadiga Samaja Bhavana - Banquet Halls In Mangalore, Gandhinagar Road, Mannagudda, Mangalore - 575003 (Near Post Office)',
        phone: '',
        image: mangalore,
        links: [
            {
                href: 'https://www.facebook.com/devadigaSamajabhavana',
                text: 'Facebook'
            },
            {
                href: 'mailto:devadigamarriage@gmail.com',
                text: 'Email'
            }
        ]
    },
    {
        id: 5,
        title: 'Devadiga Sangha Karkala',
        address: 'Karkala',
        phone: '08258-231211',
        image: karkala,
        links: [
            {
                href: 'https://www.facebook.com/p/Devadiga-Sudharaka-Sangha-Karkala-100068248386679/',
                text: 'Facebook'
            }
        ]
    },
    {
        id: 6,
        title: 'Devadiga Sangha Bangalore',
        address: '#6 ,Ideal Homes Township, RR Nagar, Bengaluru,Karnataka 560098',
        phone: '+919845042887 +919945177731',
        links: [
            {
                href: 'https://www.instagram.com/devadigasanghabangalore/',
                text: 'Instagram'
            },
            {
                href: 'https://www.facebook.com/profile.php?id=100010314017471',
                text: 'Facebook'
            },
            {
                href: 'mailto:bangaloredevadigasangha@gmail.com',
                text: 'Email'
            }
        ]
    },
    {
        id: 7,
        title: 'Devadiga Sangha Surathkal [ದೇವಗಿರಿ ,ಹೊಸಬೆಟ್ಟು - ಸುರತ್ಕಲ್]',
        address: 'Surathkal',
        phone: '',
        image: surathkal,
        links: [
            {
                href: 'https://www.facebook.com/devadigasurathkal09',
                text: 'Facebook'
            }
        ]
    },
    {
        id: 8,
        title: 'Devadiga Navodaya Sangha -R- Bangalore',
        address: 'Bangalore, India, Karnataka',
        phone: '093807 68433',
        links: [
            {
                href: 'https://www.instagram.com/devadiga_navodaya_sangha_blr/',
                text: 'Instagram'
            },
            {
                href: 'https://www.facebook.com/DNSBlr/',
                text: 'Facebook'
            },
            {
                href: 'https://www.youtube.com/@dnsblr',
                text: 'Youtube'
            },
            {
                href: 'mailto:devadiganavodayasangha@gmail.com',
                text: 'Email'
            }
        ]
    },
    {
        id: 9,
        title: 'Devadiga sangha Pune',
        address: 'pune',
        phone: '',
        links: [
            {
                href: 'https://www.facebook.com/groups/503149879723932/',
                text: 'Facebook'
            }
        ]
    },
    {
        id: 10,
        title: 'Dubai Devadiga Sangha',
        address: 'Dubai, UAE',
        phone: '',
        links: [
            {
                href: 'https://www.google.com/search?q=Dubai+Devadiga+Sangha',
                text: 'Google'
            }
        ]
    },
    {
        id: 11,
        title: 'Devadiga sangha bappanadu',
        address: '3QWM+5RC, Bappanadu Rd, Karnad, Mulki, Hejamadi, Karnataka 574154',
        phone: '',
        links: [
            {
                href: 'https://www.google.com/search?q=Devadiga+sangha+bappanadu',
                text: 'Google'
            }
        ]
    },
    {
        id: 12,
        title: 'Devdiga sudharaka sangha,udyavara (R) ದೇವಡಿಗರ ಸುಧಾರಕ ಸಂಘ,ಉದ್ಯಾವರ (ರಿ)',
        address: 'Bus Stop, Shambu Kallu temple, Udyavara, Udupi, Karnataka 574118',
        phone: '',
        links: [
            {
                href: 'https://www.google.com/search?q=Devdiga+sudharaka+sangha',
                text: 'Google'
            }
        ]
    },
    {
        id: 13,
        title: 'Devadiga Sangha Kapu Mallar Grama',
        address: '6QG3+X5, Padu, Karnataka 574106',
        phone: '',
        links: [
            {
                href: 'https://www.google.com/search?q=Devadiga+Sangha+Kapu+Mallar+Grama',
                text: 'Google'
            }
        ]
    },
    {
        id: 14,
        title: 'Devadiga Sangha Mudabidri',
        address: 'Mudabidri',
        phone: '',
        links: [
            {
                href: 'https://www.facebook.com/p/Devadiga-sangha-moodbidri-100064738057069/',
                text: 'Facebook'
            }
        ]
    },
    {
        id: 15,
        title: 'Devadiga Sangha Pavanje',
        address: 'Pavanje',
        phone: '',
        links: [
            {
                href: 'https://www.facebook.com/devadigasangha.pavanje/',
                text: 'Facebook'
            }
        ]
    },
    {
        id: 16,
        title: 'ದೇವಾಡಿಗ ಸಮಾಜ ಸೇವಾ ಸಂಘ(ರಿ.) ಬೈಂದೂರು ವಲಯ',
        address: 'ಬೈಂದೂರು',
        phone: '',
        links: [
            {
                href: 'https://www.facebook.com/groups/1457764307878788',
                text: 'Facebook'
            }
        ]
    },
    {
        id: 17,
        title: 'ದೇವಾಡಿಗ ಆಕ್ಷಯ ಕಿರಣ ಸೇವಾ ಫೌಂಡೇಶನ್ (ರಿ.)',
        address: '',
        phone: '',
        links: [
            {
                href: 'https://www.facebook.com/groups/293730294033412',
                text: 'Facebook'
            }
        ]
    },
    {
        id: 18,
        title: 'Devadiga Sangha Mumbai Asalpha LCC',
        address: 'Mumbai',
        phone: '',
        links: [
            {
                href: 'https://www.facebook.com/DSMAsalfaRockstars007/',
                text: 'Facebook'
            },
            {
                href: 'mailto:asalpha.devadigasangha@gmail.com',
                text: 'Email'
            }
        ]
    },
    {
        id: 19,
        title: 'Devadiga Yuvasangatane - Hiriyadka',
        address: 'Hiriyadka',
        phone: '',
        image: Devadigayuvasangatane,
        links: [
            {
                href: 'https://www.facebook.com/Devadigayuvasangatane',
                text: 'Facebook'
            }
        ]
    },
    {
        id: 20,
        title: 'Devadiga Sabha Bhavana',
        address: 'SH 65, Hiriydaka, Karnataka 576113',
        phone: '',
        image: dsbhiriyadka,
        links: [ ]
    },
    {
        id: 21,
        title: 'ದೇವಾಡಿಗ ವೆಲ್ಫೇರ್ ಅಸೋಸಿಯೇಶನ್ (ರಿ) ಮುಂಬಯ',
        address: 'Mumbai',
        phone: '7666985238 | Whatsapp: 9773390729/9769216405',
        image: DevadigaWelfareAssociation,
        links: [
            {
                href: 'https://www.devadigawelfare.com/',
                text: 'Website'
            },
            {
                href: 'https://www.facebook.com/devadigawelfare',
                text: 'Facebook'
            },
            {
                href: 'https://www.youtube.com/channel/UCKzmyJ8gz1zJSLLR-6jaAvg',
                text: 'Youtube'
            },
            {
                href: 'mailto:devadigawelfare@gmail.com',
                text: 'Email'
            }
        ]
    },
    // Add more blog entries as needed
];

export default SanghaData;
